/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const routineCreatePreviewBodyExpectedVersionExclusiveMin = 0;
export const routineCreatePreviewBodyExpectedVersionMax = 9007199254740991;

export const routineCreatePreviewBodyRoutineStartLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const routineCreatePreviewBodyRoutineAnchorClockLocalRegExp = new RegExp(
  '^(?:[01]\\d|2[0-3]):[0-5]\\d$',
);
export const routineCreatePreviewBodyRoutineRotationCountExclusiveMin = 0;
export const routineCreatePreviewBodyRoutineRotationCountMax = 2147483647;

export const routineCreatePreviewBodyRoutineSectionsItemStartWeekdayMax = 7;

export const routineCreatePreviewBodyRoutineSectionsItemStartLocalMinuteMin = 0;
export const routineCreatePreviewBodyRoutineSectionsItemStartLocalMinuteMax = 1439;

export const routineCreatePreviewBodyRoutineSectionsItemEndWeekdayMax = 7;

export const routineCreatePreviewBodyRoutineSectionsItemEndLocalMinuteMin = 0;
export const routineCreatePreviewBodyRoutineSectionsItemEndLocalMinuteMax = 1439;

export const routineCreatePreviewBodyRoutineSectionsItemFullWeekDefault = false;
export const routineCreatePreviewBodyRoutineSectionsMax = 14;

export const routineCreatePreviewBodyRoutineParticipantsItemOrdinalMin = 0;
export const routineCreatePreviewBodyRoutineParticipantsItemOrdinalMax = 19;

export const routineCreatePreviewBodyRoutineParticipantsItemUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const routineCreatePreviewBodyRoutineParticipantsMax = 20;

export const routineCreatePreviewBodyRoutineEndedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineCreatePreviewBodyWindowDisplayTimeZoneMax = 100;

export const routineCreatePreviewBodyWindowReferenceDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const routineCreatePreviewBodyWindowRangeDefault = `two-weeks`;
export const RoutineCreatePreviewBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(routineCreatePreviewBodyExpectedVersionExclusiveMin)
    .max(routineCreatePreviewBodyExpectedVersionMax),
  routine: zod.object({
    name: zod.string(),
    startLocalDate: zod.iso.date().regex(routineCreatePreviewBodyRoutineStartLocalDateRegExp),
    anchorClockLocal: zod.string().regex(routineCreatePreviewBodyRoutineAnchorClockLocalRegExp),
    rotation: zod.object({
      unit: zod.enum(['day', 'week']),
      count: zod
        .int()
        .gt(routineCreatePreviewBodyRoutineRotationCountExclusiveMin)
        .max(routineCreatePreviewBodyRoutineRotationCountMax),
    }),
    sections: zod
      .array(
        zod.object({
          startWeekday: zod
            .int()
            .min(1)
            .max(routineCreatePreviewBodyRoutineSectionsItemStartWeekdayMax),
          startLocalMinute: zod
            .int()
            .min(routineCreatePreviewBodyRoutineSectionsItemStartLocalMinuteMin)
            .max(routineCreatePreviewBodyRoutineSectionsItemStartLocalMinuteMax),
          endWeekday: zod
            .int()
            .min(1)
            .max(routineCreatePreviewBodyRoutineSectionsItemEndWeekdayMax),
          endLocalMinute: zod
            .int()
            .min(routineCreatePreviewBodyRoutineSectionsItemEndLocalMinuteMin)
            .max(routineCreatePreviewBodyRoutineSectionsItemEndLocalMinuteMax),
          fullWeek: zod
            .boolean()
            .default(routineCreatePreviewBodyRoutineSectionsItemFullWeekDefault),
        }),
      )
      .min(1)
      .max(routineCreatePreviewBodyRoutineSectionsMax),
    participants: zod
      .array(
        zod.object({
          ordinal: zod
            .int()
            .min(routineCreatePreviewBodyRoutineParticipantsItemOrdinalMin)
            .max(routineCreatePreviewBodyRoutineParticipantsItemOrdinalMax),
          userId: zod.uuid().regex(routineCreatePreviewBodyRoutineParticipantsItemUserIdRegExp),
        }),
      )
      .min(1)
      .max(routineCreatePreviewBodyRoutineParticipantsMax),
    endedAt: zod
      .union([
        zod.iso.datetime({ offset: true }).regex(routineCreatePreviewBodyRoutineEndedAtOneRegExp),
        zod.null(),
      ])
      .optional(),
  }),
  window: zod.object({
    displayTimeZone: zod.string().min(1).max(routineCreatePreviewBodyWindowDisplayTimeZoneMax),
    referenceDate: zod.iso.date().regex(routineCreatePreviewBodyWindowReferenceDateRegExp),
    range: zod
      .enum(['one-day', 'one-week', 'two-weeks', 'one-month'])
      .default(routineCreatePreviewBodyWindowRangeDefault),
  }),
});

export type RoutineCreatePreviewBody = zod.input<typeof RoutineCreatePreviewBody>;
export type RoutineCreatePreviewBodyOutput = zod.output<typeof RoutineCreatePreviewBody>;
